/** `null` means unlimited. Mirrors server `getStudentLimitForPlan`. */
export type StudentLimit = number | null;

/**
 * Max students for a billing plan name (`user.pricePlanName`).
 * No plan / unknown plan → free tier (5).
 */
export const getStudentLimitForPlan = (
  pricePlanName: string | null | undefined,
): StudentLimit => {
  const name = pricePlanName?.trim() ?? '';
  if (name === 'OnTime Starter') return 15;
  if (name === 'OnTime School') return 200;
  if (name === 'OnTime Campus') return null;
  return 5;
};

export const formatStudentLimitMessage = (
  limit: StudentLimit,
  currentCount: number,
): string => {
  if (limit === null) {
    return `${currentCount} student${currentCount === 1 ? '' : 's'} (unlimited plan).`;
  }
  return `${currentCount} of ${limit} students used on your plan.`;
};
